const contantsTypes = {
    FETCH_CONSTANTS: 'FETCH_CONSTANTS',
    SET_CONSTANTS: 'SET_CONSTANTS',
};

export default contantsTypes;

interface HSConstants {
    label: string;
    value: string;
}

export interface Countries {
    code: string;
    dialCode: string;
    name: string;
    nationality: string;
    coordinates: [number, number];
}

export interface Constants {
    idTypes: HSConstants[];
    individualAccreditation: string[];
    institutionalAccreditation: string[];
    nationalities: HSConstants[];
    residentialStatus: HSConstants[];
    countries: Countries[];
}

export interface constantAPI {
    idTypes: string[];
    individualAccreditation: string[];
    institutionalAccreditation: string[];
    nationalities: string[];
    residentialStatus: string[];
    countries: Countries[];
}

export interface ConstantsState {
    constants: Constants;
}
